// extracted by mini-css-extract-plugin
module.exports = {"container":"HiddenDemoCard_container__ZYZKS","title":"HiddenDemoCard_title__2_emJ","desc":"HiddenDemoCard_desc__jWfM0","descNoMargin":"HiddenDemoCard_descNoMargin__1gb4E"};